import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { userKeys } from "./query-keys";

interface UseUsersParams {
  offset?: number;
  limit?: number;
}

export function useUsers({ offset = 0, limit = 20 }: UseUsersParams = {}) {
  const page = Math.floor(offset / limit) + 1;

  return useQuery({
    queryKey: userKeys.list({ page, size: limit }),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/admin/users", {
        params: { query: { page, size: limit } },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
